import { useMutation } from '@tanstack/react-query';
import { AI_API } from 'utils/globalApiServices';
import Organization from 'infrastructure/Organization';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const mutationFn = async ({ assignment_uuid, scenario_uuid, body = {} }) => {
  const org_id = Organization.getSelectedOrg()?.id;
  const url = `/orgs/${org_id}/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/`;
  const { data } = await AI_API.post(url, { ...body });
  return data;
};

const useCreateRealPlaySessionMutation = () => {
  const { setSessionInfoTemp } = useRealplayStore();
  return useMutation({
    mutationFn,
    onSuccess: (response) => {
      setSessionInfoTemp(response);
    },
    onError: () => {
      setSessionInfoTemp({});
    },
  });
};

export default useCreateRealPlaySessionMutation;
